import { Typography } from "@mui/material";
import React from "react";
import "../MembershipRegistration/register.css";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid2";
import TextInput from "../../components/TextInput/TextInput";
import Button from "@mui/material/Button";
import { useForm } from "react-hook-form";
import InfinityEncryptor from "../../components/EncryptDecrypt/InfinityEncryptor";
import axios from "axios";
import { styled } from "@mui/material/styles";
import RowRadioButtonsGroup from "../../components/Radio/RowRadioButtonsGroup";
import { notification } from "antd";
import CustomSeparator from "../../layouts/AdminLayout/Header/Breadcrumbs";

const DrawerHeader = styled("div")(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "flex-end",
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
}));
const CreateDocumentCategories = () => {
  const [api, contextHolder] = notification.useNotification();
  const userID = localStorage.getItem('userID');

  const openNotificationWithIcon = (type) => {
    api[type]({
      message: "Success",
      description: "Your data has been saved successfully!",
    });
  };

  const API_BASE_URL =
  window.location.hostname === "localhost"
    ? "http://localhost/api_server"
    : "https://www.ppkm.org.my/api_server";

  //parameters declaration
  const key = "12345";
  /* key has no length limit, the longer the length more exhaustive encryption/decryption to process. Key shall not have 0, any 0's will be autoremoved */

  const mode = "YMDHI"; //optional parameter, default will be 'YMDHI'

  //initialize encyptor
  const Encryptor = new InfinityEncryptor(key, mode);

  const {
    handleSubmit,
    register,
    formState: { errors },
    control,
    reset,
  } = useForm({
    defaultValues: {
      userID: userID,
      documentCategoryName: "",
    },
  });

  async function submitForm(data) {
    const config = {
      headers: {
        "content-type": "multipart/form-data",
      },
    };
    try {
      const response = await axios.post(
        `${API_BASE_URL}/submit_document_category/`,
        data,
        config
      );

      return response.data;
    } catch (error) {
      console.log("API request failed:", error);
    }
  }

  const onSubmit = async (data) => {
    const formData = new FormData();
    formData.append("userID", data.userID);

    formData.append(
      "documentCategoryName",
      Encryptor.Encrypt(data.documentCategoryName)
    );

    try {
      const response = await submitForm(formData);
      console.log(response);
      if (response.status === "success") {
        reset();

        openNotificationWithIcon("success");
        window.scrollTo({ top: 0, behavior: "smooth" });
      }
    } catch (error) {
      console.log("Form submission failed: ", error);
    }
  };

  const onInvalid = (errors) => {
    console.log("Form has errors:", errors);
  };

  return (
    <>
      <Box
        sx={{
          display: "flex",
          backgroundColor: "#e8e8e8",
          height: "100vh",
          width: "100vw",
        }}
      >
        <Box component="main" sx={{ flexGrow: 1, p: 3 }}>
          <DrawerHeader />

          <CustomSeparator pageName="resources_category" />
          {contextHolder}

          <Typography
            gutterBottom
            variant="h4"
            sx={{ color: "text.secondary" }}
          >
            Create Resources Category
          </Typography>
          <form
            onSubmit={handleSubmit(onSubmit, onInvalid, {
              shouldFocusError: true,
            })}
          >
            <Box sx={{ flexGrow: 1, maxWidth: "auto", maxHeight: "auto" }}>
              <Grid container spacing={2}>
                <Grid size={{ xs: 12, md: 12 }}>
                  <label>Resources Category Name</label>
                  <TextInput
                    type="text"
                    {...register("documentCategoryName", {
                      required: "This field is required",
                    })}
                    onErrorCheck={
                      errors.documentCategoryName
                        ? errors.documentCategoryName.message
                        : ""
                    }
                    control={control}
                  />
                </Grid>
              </Grid>

              <Box textAlign="center">
                <Button
                  sx={{
                    borderRadius: "20px",
                    mt: 4,
                    mb: 4,
                    width: "100%",
                    height: "48px",
                    backgroundColor: "#d33333",
                  }}
                  variant="contained"
                  type="submit"
                >
                  <Typography variant="h6">Save</Typography>
                </Button>
              </Box>
            </Box>
          </form>
        </Box>
      </Box>
    </>
  );
};

export default CreateDocumentCategories;
